var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListUnordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.72 3.427c.951 0 1.722-.768 1.722-1.708S2.67.01 1.72.01C.77.008 0 .775 0 1.715c0 .94.774 1.711 1.72 1.711zm0-2.625c.51 0 .922.412.922.914a.92.92 0 0 1-1.842 0 .92.92 0 0 1 .92-.914zM1.72 8.703c.951 0 1.722-.768 1.722-1.708S2.67 5.287 1.72 5.287C.77 5.287 0 6.052 0 6.995s.774 1.708 1.72 1.708zm0-2.622c.51 0 .922.412.922.914a.92.92 0 0 1-1.842 0c0-.505.415-.914.92-.914zM1.72 13.982c.951 0 1.722-.768 1.722-1.708 0-.943-.774-1.708-1.721-1.708-.947 0-1.721.768-1.721 1.708s.774 1.708 1.72 1.708zm0-2.625c.51 0 .922.412.922.914a.92.92 0 1 1-1.842 0 .92.92 0 0 1 .92-.914zM5.744 2.115h9.845a.4.4 0 0 0 .401-.399.4.4 0 0 0-.401-.399H5.744a.4.4 0 0 0-.402.399.4.4 0 0 0 .402.399zM5.744 7.394h9.845a.4.4 0 0 0 .401-.399.4.4 0 0 0-.401-.398H5.744a.4.4 0 0 0-.402.398.4.4 0 0 0 .402.399zM5.744 12.67h9.845a.4.4 0 0 0 .401-.399.4.4 0 0 0-.401-.399H5.744a.4.4 0 0 0-.402.4.4.4 0 0 0 .402.398z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListUnordered);
export default __webpack_public_path__ + "static/media/list-unordered.d3df04f336fcf40f37015c2f5ac8588c.svg";
export { ForwardRef as ReactComponent };